/**
 * Valores de ambiente derivados, num lugar só.
 *
 * `widgetSrc` importa para o snippet de instalação: em produção o widget é servido pelo Hosting na
 * raiz (`/widget.js`, ver `firebase.json`); em desenvolvimento ele vem do testbed, que serve o
 * arquivo direto do build do SDK.
 */

import { apiBase as firebaseApiBase, projectId } from './firebase.js';
import { isDemoMode } from '../data/index.js';

const env = import.meta.env;

export const apiBase = (env.VITE_API_BASE as string | undefined) ?? firebaseApiBase;

export const widgetSrc =
  (env.VITE_WIDGET_SRC as string | undefined) ??
  (projectId ? `https://${projectId}.web.app/widget.js` : 'http://localhost:5175/widget.js');

/** Etiqueta mostrada no header quando não há Firebase por trás. */
export const isDemoModeLabel = isDemoMode ? 'modo demo (dados locais)' : null;
